<template>
	<nav class="bg-white relative shadow z-10">
		<app-header :auth="$attrs.auth"/>
	</nav>
</template>
<script setup>


// Retrieve the value from localStorage on component mount
import {onMounted} from "vue";
import { router } from '@inertiajs/vue3'
import AppHeader from "@/Layouts/AppHeader.vue";

onMounted(() => {
	const url = window.location.href;
	const isRepositoryIndexPage = url.endsWith('/repository/');
	const isRepositoryPage = url.endsWith('/repository');

	const activeCollection = localStorage.getItem('activeCollection');

	if (isRepositoryIndexPage) {
		const redirectPath = activeCollection ? activeCollection : 'personal';
		Inertia.visit(redirectPath);
	} else if (isRepositoryPage) {
		const redirectPath = activeCollection ? `repository/${activeCollection}` : 'repository/personal';
		Inertia.visit(redirectPath);
	}
})

</script>

